import React, { useRef, useState } from 'react';
import {
   Backdrop,
   Box,
   Button,
   Grid,
   IconButton,
   Paper,
   Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import { AlertLabel, Input, TextArea } from '../../../assets/styled/Element';
import { Controller, useForm } from 'react-hook-form';
import Axios from 'axios';
import LoadingPopup from '../../Loading/LoadingPopup';
import ErrorPopup from '../../Error/ErrorPopup';
import { useSnackbar } from 'notistack';
import { TitleLabel } from '../../Element/LabelInputForm';
import { reverseFormatNumber } from '../../../configs/helpers/utility';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';

const useStyles = makeStyles((theme) => ({
   backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
   },
   paper: {
      padding: theme.spacing(2, 4, 3),
      width: '500px',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
   },
   role: {
      color: '#5858FA',
   },
   title: {
      color: '#6E6E6E',
   },
   large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   content: {
      margin: theme.spacing(0, 1),
      width: '100%',
   },
   headerL: {
      margin: theme.spacing(1),
   },
   listStyle: {
      height: '65px',
   },
   flexGrid: {
      display: 'flex',
      alignItems: 'center',
   },
   qrPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
   },
   detailRight: {
      height: '280px',
      overflow: 'auto',
   },
}));

function Decrease(props) {
   const classes = useStyles();
   const [data, setData] = useState(props.data);
   const [isLoading, setIsLoading] = useState(false);
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const closeRef = useRef();
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const {
      handleSubmit,
      control,
      register,
      errors,
      watch,
      setValue,
      getValues,
   } = useForm({
      defaultValues: {
         rewardName: `${data.nameTh} | ${data.nameEn}`,
         rewardRef: data.rewardRef,
         total: new Intl.NumberFormat().format(data.qty),
      },
   });
   const onSubmit = (e) => {
      sessionStorage.setItem('value', JSON.stringify(e));
      if (sessionStorage['value']) {
         const values = JSON.parse(sessionStorage.getItem('value'));
         postData(values);
      }
   };
   const postData = (values) => {
      setIsLoading(true);
      const result = {
         rewardRef: data.rewardRef,
         qty: +reverseFormatNumber(values.qty, 'en'),
         remark: values.remark,
      };
      Axios.post('/GSB/dashboard/reward/WithdrawStock', result)
         .then((resp) => {
            // console.log(resp);
            enqueueSnackbar('ลดจำนวนของรางวัล สำเร็จ!!', {
               variant: 'success',
            });
            props.onSuccess();
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            sessionStorage.removeItem('value');
            setIsLoading(false);
         });
   };
   if (isError.error)
      return (
         <ErrorPopup
            onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );
   return (
      <Paper className={classes.paper}>
         <Backdrop className={classes.backdrop} open={isLoading}>
            <LoadingPopup />
         </Backdrop>
         <div className={classes.header}>
            <Typography variant={'h4'}>ลดจำนวนของรางวัล</Typography>
            <IconButton
               className={classes.headerL}
               size={'small'}
               onClick={props.onClickClose}
               ref={closeRef}
            >
               <FontAwesomeIcon icon={faTimesCircle} />
            </IconButton>
         </div>
         <form onSubmit={handleSubmit(onSubmit)}>
            <Box
               display={'flex'}
               alignItems={'flex-start'}
               flexDirection={'column'}
               fontSize={20}
            >
               <Box display={'flex'} width={'100%'}>
                  <Grid container spacing={1}>
                     <Grid item xs={6}>
                        <TitleLabel>ชื่อของรางวัล</TitleLabel>
                        <Input name={'rewardName'} disabled ref={register()} />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>รหัสอ้างอิง</TitleLabel>
                        <Input name={'rewardRef'} disabled ref={register()} />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>ของรางวัลคงเหลือ</TitleLabel>
                        <Controller
                           as={
                              <Input
                                 textAlign={'right'}
                                 placeholder={'ของรางวัลคงเหลือ'}
                                 disabled
                              />
                           }
                           onChange={([e]) => {
                              return new Intl.NumberFormat().format(
                                 e.target.value.replace(/[^0-9]/g, ''),
                              );
                           }}
                           name={'total'}
                           control={control}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           จำนวนของรางวัลที่ลด
                           {(errors.qty || errors.qty) && (
                              <AlertLabel>{errors.qty.message}</AlertLabel>
                           )}
                        </TitleLabel>
                        <Controller
                           as={
                              <Input
                                 textAlign={'right'}
                                 placeholder={'จำนวนของรางวัลที่ลด'}
                              />
                           }
                           rules={{
                              required: 'กรุณาระบุจำนวนของรางวัล',
                              min: {
                                 value: 1,
                                 message: 'จำนวนของรางวัลต้องมากกว่า 0',
                              },
                           }}
                           onChange={([e]) => {
                              return new Intl.NumberFormat().format(
                                 e.target.value.replace(/[^0-9]/g, ''),
                              );
                           }}
                           name='qty'
                           control={control}
                        />
                     </Grid>
                     <Grid item xs={12}>
                        <TitleLabel>
                           หมายเหตุ
                           {(errors.remark || errors.remark) && (
                              <AlertLabel>กรุณาระบุเหตุผล</AlertLabel>
                           )}
                        </TitleLabel>
                        <TextArea
                           name={'remark'}
                           ref={register({ required: true })}
                        />
                     </Grid>
                  </Grid>
               </Box>
               <Box mt={3}>
                  <Box>
                     <Button
                        variant={'contained'}
                        color={'primary'}
                        type={'submit'}
                     >
                        ยืนยัน
                     </Button>
                     <Button variant={'contained'} onClick={props.onClickClose}>
                        ยกเลิก
                     </Button>
                  </Box>
               </Box>
            </Box>
         </form>
      </Paper>
   );
}

export default Decrease;
